import { COLORS } from "@tCentro/theme/design";

export default {
    small: `0 0 1px 0 ${COLORS.shadow.light}, 0 4px 8px 0 ${COLORS.shadow.base}`,
    main: `0 0 1px 0 ${COLORS.shadow.light}, 0 8px 16px 0 ${COLORS.shadow.base}`,
};
